<template>
  <div class="page-opportunities">

    <div v-for="(block, index) in blocks" :key="`block-${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top is-gap-top-bottom" data-aos="fade-in" data-aos-once="true">
      <div class="is-gap is-pad has-text-left">
        <div class="showdown" v-if="content" v-html="content" />
      </div>
    </div>

    <external></external>

    <div class="container is-gap-top color-lightgreen-bg"
      v-for="(item, index) in events" :key="`oppr-${index}`"
      data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <div class="is-gap is-pad">
            <div class="columns is-gapless is-flex is-multiline">

              <div class="column is-12-mobile is-12-tablet is-10-desktop is-10-widescreen has-text-left">
                <div class="is-gap-large">
                  <div>
                    <b>{{ item && item.title }}</b>
                  </div>
                  <div class="is-gap-top">
                    Available States: {{ item && item.location }}
                  </div>
                  <div class="is-gap-top">
                    Posted: {{ item && item.created_at && Util.date.fromNow(item.created_at) }}
                  </div>
                </div>
              </div>

              <div class="column is-12-mobile is-12-tablet is-2-desktop is-2-widescreen"
                :class="[(isDesktop ? 'has-text-right' : 'has-text-left')]">
                <el-button class="button color-green-bg is-gap"
                  @click="onPlacement(index)">
                  Send Resume
                </el-button>
                <el-button class="button color-green-bg is-gap"
                  @click="onDialog(index)">
                  More Info
                </el-button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <dialogg
      :visible="dialogVisible"
      :no-cancel="true"
      :ok-string="'Close Window'"
      :width-desktop="'85%'"
      :width-mobile="'90%'"
      @on-close="() => { dialogVisible = false }"
      @on-submit="onDialogSubmit">
      <div class="has-text-left" v-if="selectedItem">
        <h1 v-if="selectedItem.title" style="word-break:break-word;">
          {{ selectedItem.title }}
        </h1>
        <hr />
        <h3 class="is-gap-top is-gap-large-bottom"
          v-if="selectedItem.subtitle"
          style="word-break:break-word;">
          {{ selectedItem.subtitle }}
        </h3>
        <div class="showdown is-gap-top"
          v-html="Util.string.showdown(selectedItem.content)"
          style="word-break:break-word;">
        </div>
      </div>
    </dialogg>

  </div>
</template>

<script>
// import _ from 'lodash'
import Util from '@/util'
import Site from '@/apis/site'
import EventBus from '@/controllers/EventBus'

import InfoBlock from '@/pages/base/infoblock'
import Dialogg from '@/components/dialog'
import External from './external'

export default {
  name: 'page-opportunities',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
    Dialogg,
    External,
  },
  data () {
    return {
      loading: false,
      isDesktop: true,
      // opportunities: EventBus._data.opportunities,
      selectedIndex: -1,
      dialogVisible: false,
      blocks: [],
      events: [],
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    selectedItem: function () {
      let index = this.selectedIndex
      let list = this.events
      if (index == null || index >= (list && list.length)) return {}
      return list[index]
    },

    // subtitle: function () {
    //   return 'Interested In Working With AIS?'
    // },
    //
    // description: function () {
    //   return 'Join our highly qualified, trained and certified team!'
    // },

    content: function () {
      let block = this.blocks && this.blocks.length > 0 && this.blocks[0]
      let content = block && block.content
      return Util.string.showdown(content)
    }
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    async refresh () {
      try {
        this.$set(this, 'loading', true)

        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        promise = this.getEvents()
        promises.push(promise)
        await Promise.all(promises)

        // (function(d, s, id) { var js; if (d.getElementById(id)) { var child; child = d.getElementById(id); child.parentNode.removeChild(child); } js = d.createElement(s);
        //   js.id = id;
        //   js.src = 'https://alliedinstructionalservices.bamboohr.com/js/embed.js';
        //   d.getElementsByTagName('head')[0].appendChild(js); }(document, 'script', 'EmbedSocialHashtagScript'))

        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-opportunities')
      // console.log('-- opp', data)
      this.$set(this, 'blocks', data)
    },

    async getEvents () {
      this.$set(this, 'events', [])
      let data = await Site.events()
      // console.log('-- events', data)
      this.$set(this, 'events', data)
    },

    onDialog (index) {
      this.$set(this, 'selectedIndex', index)
      this.$set(this, 'dialogVisible', true)
    },

    onDialogSubmit () {
      this.$set(this, 'dialogVisible', false)
    },

    onPlacement (index) {
      let field = this.events[index].title
      this.$router.push({ name: 'opportunities.form', query: { field } })
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-opportunities {
  .rounded-wrapper {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: lightgray;
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
}

</style>
